import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { IListType } from "../store";
import { notification } from "antd";
import returnDataAccess from "src/dataAccess/returns/returnDataAccess";
import policiesDataAccess from "src/dataAccess/policies/policiesDataAccess";

export const getPoliciesListSuccess = createAction<any>(
    "[Policies] Get Policies List Success"
);
export const LoadingData = createAction<boolean>("[Policies] Loading data");
export const loadingList = createAction<boolean>("[Policies] Loading list");

export const getPoliciesListAsync = createAsyncThunk<any, IListType>(
    "[Policies] Get Policies List",
    async (parameter, thunkAPI) => {
        thunkAPI.dispatch(loadingList(true));

        const result = await policiesDataAccess
            .policyList(parameter)
            .then((res) => {
                thunkAPI.dispatch(getPoliciesListSuccess(res));
                thunkAPI.dispatch(loadingList(false));
                return res;
            });
        return result;
    }
);

export const savePoliciesListSuccess = createAction<any>(
  "[Policies] Save Policies List Success"
);



export const deletePoliciesAsync = createAsyncThunk<any, number | number[]>(
    "[Policies] Delete Policies(s)",
    async (policiesIdOrIds, thunkAPI) => {
        const idsToDelete: number[] = Array.isArray(policiesIdOrIds)
            ? policiesIdOrIds
            : [policiesIdOrIds];
        await policiesDataAccess.deletePolicy(idsToDelete);
        const count = idsToDelete.length;
        const message = `${count} policies${count === 1 ? "" : "s"} deleted successfully`;

        notification.success({ message });
        thunkAPI.dispatch(deletePoliciesSuccess(idsToDelete));
        return idsToDelete;
    }
);

export const deletePoliciesSuccess = createAction<number[]>(
    "[Policies] Delete Policies Success"
);


export const getPoliciesDocumentListSuccess = createAction<any>(
    "[Policies] Get Policies Document List Success"
);
export const getPoliciesDocumentListAsync = createAsyncThunk<any, IListType>(
    "[Policies] Get Policies Document List",
    async (parameter, thunkAPI) => {
        thunkAPI.dispatch(loadingList(true));

        const result = await policiesDataAccess
            .getPolicyDocumentList(parameter)
            .then((res) => {
                thunkAPI.dispatch(getPoliciesDocumentListSuccess(res));
                thunkAPI.dispatch(loadingList(false));
                return res;
            });
        return result;
    }
);

